import map from 'lodash/map'
import { useRouter } from 'next/router'
import React, { useMemo, VFC } from 'react'

import { SizeTableTable, StyledGuideAccordion } from '@Components/Product/SizeGuide/styledElements'
import { Product } from '@Generated/graphql'
import { getSizeInformation } from '@Globals/CMS/ProductHelpers'
import { useTranslation } from '@Globals/Translations'

interface SizeTableProps {
  product?: Product
}

export const SizeTable: VFC<SizeTableProps> = ({ product }) => {
  const { locale = 'en-GB' } = useRouter()
  const { t } = useTranslation('products')
  const sizeData = useMemo(() => getSizeInformation(locale, product), [locale, product])

  if (!sizeData) {
    return null
  }

  return (
    <>
      {map(sizeData, sizeBlock => (
        <StyledGuideAccordion
          key={sizeBlock.key || 'unknown'}
          header={
            // key is not defined when a product only have a single variant
            sizeBlock.key
              ? `${t('PP_DIMENSIONS_WRIST_FIT')} - ${sizeBlock.key}`
              : t('PP_DIMENSIONS_WRIST_FIT')
          }
        >
          <SizeTableTable>
            <thead>
              <tr>
                <th>{t('PP_DIMENSIONS_WRIST_CIRCUMFERENCE')}</th>
                <th>{t('PP_DIMENSIONS_WRIST_FIT')}</th>
              </tr>
            </thead>
            <tbody>
              {map(sizeBlock.data, entry => (
                <tr key={entry.size}>
                  <th>{entry.size}</th>
                  <td>{entry.fit}</td>
                </tr>
              ))}
            </tbody>
          </SizeTableTable>
        </StyledGuideAccordion>
      ))}
    </>
  )
}
